<template>
  <div class="work">
    <h1>Work Experience</h1>
    <div class="container">
      <ExperienceData 
        :data="`Jul 2022 — Jul 2023`"
        :position="`Full-Stack Developer at DataCode srl`"
        :text="`Designed and maintained high-performance web applications using React.js and Node.js. Improved frontend productivity by streamlining component architecture and workflows. Optimized image and media loading strategies, reducing load times by up to 40% and enhancing overall user experience. Leveraged TypeScript to build scalable and maintainable code. Contributed to system architecture and mentored junior developers while ensuring full cross-browser compatibility.`"
      />
      <ExperienceData
        :data="`Jul 2023 — Mar 2024`"
        :position="`Full-Stack Developer at MeWay`"
        :text="`Led end-to-end development of AI-powered projects — from ER schema design to production deployment — serving 1000+ users. Architected and built microservices using NestJS, React, BullMQ, and TypeScript. Integrated multiple AI APIs including ChatGPT, ElevenLabs (TTS/STT), Hugging Face, and various LLMs for video generation, image synthesis, text translation, and more. Developed a loop detector in Python with no open-source analogue, and implemented PayPal payment integration. Successfully led projects that attracted two US-based clients, resulting in signed partnership agreements with the company. Gained hands-on experience with FFmpeg for media processing and demonstrated strong adaptability in solving complex architectural challenges.`"
      />
      <ExperienceData
        :data="`Mar 2024 — Sep 2025`"
        :position="`Frontend Developer at Mentat`"
        :text="`Worked as a Frontend Developer on the Gulp web UI — a React and TypeScript application. Developed and maintained UI components using Shadcn/UI, implemented user authentication screens, session management, and operation workflows. Engineered a high-performance real-time rendering system capable of processing 15,000+ events simultaneously using Canvas API and custom-built algorithms, significantly improving UI responsiveness under heavy load. Integrated and worked with LLMs, contributing to decisions on AI model selection and training approaches. Actively influenced team-wide architectural decisions, advising on optimal tech stack choices. Focused on creating responsive, modular, and high-performance interfaces, integrating with backend APIs, and improving overall usability and developer experience.`"
      />
      <ExperienceData
        :data="`Sep 2025 — Apr 2026`"
        :position="`Full-Stack Developer at NDA`"
        :text="`Worked on high-load systems and big data solutions as a full-stack developer. Tech stack included Next.js, TypeScript, Node.js, gRPC, tRPC, ConnectRPC, and AWS S3. Project details are strictly confidential under NDA.`"
      />
    </div>
  </div>
</template>

<script>
import ExperienceData from './../../unit/component/experience.vue';

  export default {
    name: 'WorkExperiene',
    components: {
      ExperienceData
    }
  }
</script>

<style scoped>
  .work {
    width: 80%;
    padding: 5rem 0;
    display: flex;
    align-items: start;
    justify-content: center;
    flex-direction: column;
    gap: 2rem;
}

  h1 {
    width: 100%;
    text-align: center;
  }

.container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto;
  align-items: start;
  gap: 8rem;
}

@media all and ( max-width: 1024px ) {
    .container {
      gap: 4rem;
    }
  }

  @media all and ( max-width: 1024px ) {
    .container {
      grid-template-columns: repeat(1, 1fr);
      gap: 4rem;
    }
  }

</style>
